import React from 'react';
import { number, string } from 'prop-types';
import { N400 } from '@/colors/colorsV1';

const Error = ({ color, size }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.0003 1.66663C5.39795 1.66663 1.66699 5.39759 1.66699 9.99996C1.66699 14.6023 5.39795 18.3333 10.0003 18.3333C14.6027 18.3333 18.3337 14.6023 18.3337 9.99996C18.3337 5.39759 14.6027 1.66663 10.0003 1.66663ZM13.0896 6.9107C13.415 7.23614 13.415 7.76378 13.0896 8.08922L11.1788 9.99996L13.0896 11.9107C13.415 12.2361 13.415 12.7638 13.0896 13.0892C12.7641 13.4147 12.2365 13.4147 11.9111 13.0892L10.0003 11.1785L8.08958 13.0892C7.76414 13.4147 7.23651 13.4147 6.91107 13.0892C6.58563 12.7638 6.58563 12.2361 6.91107 11.9107L8.82181 9.99996L6.91107 8.08922C6.58563 7.76378 6.58563 7.23614 6.91107 6.9107C7.23651 6.58527 7.76414 6.58527 8.08958 6.9107L10.0003 8.82145L11.9111 6.9107C12.2365 6.58527 12.7641 6.58527 13.0896 6.9107Z"
      fill={color}
    />
  </svg>
);

Error.propTypes = {
  color: string,
  size: number,
};

Error.defaultProps = {
  color: N400,
  size: 20,
};

export default Error;
